import { render, staticRenderFns } from "./AddToCoverForm.vue?vue&type=template&id=18ace72e&scoped=true&"
import script from "./AddToCoverForm.vue?vue&type=script&lang=js&"
export * from "./AddToCoverForm.vue?vue&type=script&lang=js&"
import style0 from "./AddToCoverForm.vue?vue&type=style&index=0&id=18ace72e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ace72e",
  null
  
)

export default component.exports